function initStickyAtc() {
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  var sectionId = bar.dataset.sectionId;
  var productForm = document.querySelector('product-form[data-section-id="' + sectionId + '"]');
  if (!productForm) return;

  var masterSelect = productForm.querySelector('select[name="id"]');
  var sizeSelect = bar.querySelector('[data-sticky-size-select]');
  var stickyBtn = bar.querySelector('[data-sticky-atc-btn]');
  var stickyPrice = bar.querySelector('[data-sticky-atc-price]');
  var stickyText = bar.querySelector('[data-sticky-atc-text]');
  var stickySizeValue = bar.querySelector('[data-sticky-size-value]');

  // --- Price sync via MutationObserver on main submit price element ---
  var mainPriceEl = productForm.querySelector('[data-variant-price-submit]');
  if (mainPriceEl && stickyPrice) {
    new MutationObserver(function () {
      stickyPrice.textContent = mainPriceEl.textContent;
    }).observe(mainPriceEl, { childList: true, characterData: true, subtree: true });
  }

  // --- Button state sync (available / sold out / unavailable) ---
  var mainAtcInput = productForm.querySelector('[add-to-cart]');
  var mainAtcLabel = productForm.querySelector('[add-to-cart-label]');

  function syncButtonState() {
    if (!mainAtcInput || !stickyBtn) return;
    var isDisabled = mainAtcInput.hasAttribute('disabled');
    if (isDisabled) {
      stickyBtn.setAttribute('disabled', '');
      stickyBtn.classList.add('disabled');
    } else {
      stickyBtn.removeAttribute('disabled');
      stickyBtn.classList.remove('disabled');
    }
    if (stickyText) {
      stickyText.textContent = mainAtcInput.value || '';
    }
  }

  // Run once on init so sticky reflects current state immediately
  syncButtonState();

  // Observe disabled attribute changes on the main ATC input
  if (mainAtcInput) {
    new MutationObserver(syncButtonState).observe(mainAtcInput, {
      attributes: true,
      attributeFilter: ['disabled']
    });
  }

  // Also observe the label class (catches edge cases where only class changes)
  if (mainAtcLabel) {
    new MutationObserver(syncButtonState).observe(mainAtcLabel, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // --- Size select sync: main form → sticky ---
  // Use event delegation on the product form to catch all radio changes
  if (sizeSelect) {
    var optionName = sizeSelect.dataset.optionName;

    productForm.addEventListener('change', function (e) {
      if (e.target.type !== 'radio') return;
      var group = e.target.closest('.radio-option[data-option-name="' + optionName + '"]');
      if (!group || !e.target.checked) return;
      sizeSelect.value = e.target.value;
      if (stickySizeValue) stickySizeValue.textContent = e.target.value;
    });

    // Also catch master select changes (e.g. from gallery variant sync or programmatic updates)
    if (masterSelect) {
      masterSelect.addEventListener('change', function () {
        var radioGroup = productForm.querySelector('.radio-option[data-option-name="' + optionName + '"]');
        if (!radioGroup) return;
        var checkedRadio = radioGroup.querySelector('input[type="radio"]:checked');
        if (checkedRadio) {
          sizeSelect.value = checkedRadio.value;
          if (stickySizeValue) stickySizeValue.textContent = checkedRadio.value;
        }
      });
    }
  }

  // --- Size select sync: sticky → main form ---
  if (sizeSelect) {
    sizeSelect.addEventListener('change', function () {
      var value = sizeSelect.value;
      var optionName = sizeSelect.dataset.optionName;
      var radioGroup = productForm.querySelector('.radio-option[data-option-name="' + optionName + '"]');
      if (!radioGroup) return;
      var radio = radioGroup.querySelector('input[type="radio"][value="' + CSS.escape(value) + '"]');
      if (radio) {
        radio.click();
        if (stickySizeValue) stickySizeValue.textContent = value;
      }
    });
  }

  // --- Sticky button → trigger main add-to-cart ---
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var mainAtc = productForm.querySelector('[add-to-cart]');
      if (mainAtc) mainAtc.click();
    });
  }
}

// Initial run
initStickyAtc();

// Re-run whenever product-range renders a new product (replaces #main-product-container)
document.addEventListener('product-range:rendered', initStickyAtc);
